import BlVoucherEntryMv from './BlVoucherEntryMv.vue'

BlVoucherEntryMv.install = function(Vue) {
  Vue.component(BlVoucherEntryMv.name, BlVoucherEntryMv)
}

export default BlVoucherEntryMv
